import i18n from './../i18n'
import validator from 'validator'

export function validateRequired (value) {
  if (value === null || value === undefined || value === '' || value === false) {
    return {
      error: true,
      errorMessage: i18n.t('required_field')
    }
  }
  return {
    error: false
  }
}
export function validateRequiredBirthday (value) {
  let now = new Date().getFullYear()
  let dateOfBirth = new Date(value).getFullYear()
  let age = now - dateOfBirth
  if (age < 18) {
    return {
      error: true,
      errorMessage: i18n.t('birth')
    }
  } else if (value === null || value === undefined || value === '' || value === false) {
    return {
      error: true,
      errorMessage: i18n.t('required_field')
    }
  }
  return {
    error: false
  }
}

export function validateLength (value) {
  if (value.length < 80) {
    return {
      error: true,
      errorMessage: i18n.t('length')
    }
  }
  return {
    error: false
  }
}

export function validateRequiredPhone (value) {
  let regex = new RegExp(
    '^((\\+\\d{1,3}(-| )?\\(?\\d\\)?(-| )?\\d{1,3})|(\\(?\\d{2,3}\\)?))(-| )?(\\d{3,4})(-| )?(\\d{4})(( x| ext)\\d{1,5}){0,1}$'
  )
  if (!regex.test(value)) {
    return {
      error: true,
      errorMessage: i18n.t('required_field')
    }
  }
  return {
    error: false
  }
}
export function validateEmail (value) {
  let regex = new RegExp(
    "^[-a-z0-9!#$%&'*+/=?^_`{|}~]+(?:\\.[-a-z0-9!#$%&'*+/=?^_`{|}~]+)*@(?:[a-z0-9]([-a-z0-9]{0,61}[a-z0-9])?\\.)*(?:aero|arpa|asia|biz|cat|com|coop|edu|gov|info|int|jobs|mil|mobi|museum|name|net|org|pro|tel|travel|[a-z][a-z])$"
  )
  console.log(value, regex.test(value))
  if (!regex.test(value)) {
    return {
      error: true,
      errorMessage: i18n.t('required_field')
    }
  }
  return {
    error: false
  }
}

export function validateLocation (value) {
  if (!value.gmaps) {
    return {
      error: true,
      errorMessage: i18n.t('location_must_include_country')
    }
  }
  const { address_components } = value.gmaps
  const countryIndex = address_components.findIndex(el => el.types.indexOf('country') !== -1)
  if (countryIndex === -1) {
    return {
      error: true,
      errorMessage: i18n.t('location_must_include_country')
    }
  }
  return {
    error: false
  }
}

export function makeFileSizeValidator (sizeMB) {
  if (!sizeMB) sizeMB = 0
  return file => {
    if (typeof file !== 'object') {
      return {
        error: false
      }
    }
    if (file.size / 1024 / 1024 > sizeMB) {
      return {
        error: true,
        errorMessage: i18n.t('file_size_limit', { sizeMB: sizeMB })
      }
    }
    return {
      error: false
    }
  }
}

export function makeFileTypeValidator (type, displayType) {
  return file => {
    if (typeof file !== 'object') {
      return {
        error: false
      }
    }
    if (file.type !== type) {
      return {
        error: true,
        errorMessage: i18n.t('file_type_error', { fileType: displayType })
      }
    }
    return {
      error: false
    }
  }
}

export function isWebsite (value) {
  if (validator.isURL(`${value}`)) {
    return {
      error: false
    }
  } else {
    return {
      error: true,
      errorMessage: i18n.t('website_error')
    }
  }
}



// WEBPACK FOOTER //
// src/libs/validation.js